export default class Promotion {
    "promotionId": number;
    "code": string = "";
    "description": string = "";
    "type": string = "";
    "amountDiscount": number;
    "numberOfBidPeriods": number;
    "activeStartDate": Date;
    "activeEndDate": Date;
}